import { Icon } from "@blueprintjs/core"
import React from "react"

const TripsAggregateInfo = ({ vehicles, address, zoom }) => {
  return (
    <div className="vt-trip-info-window">
      <div className="vehicle">
        <div className="grid grid-cols-12 gap-4 mb-2">
          <div className="col-span-1">
            <Icon icon="drive-time" />
          </div>
          <div>
            <p className="vt-highlight">{vehicles}</p>
          </div>
        </div>
        <div className="grid grid-cols-12 gap-4 mb-2">
          <div className="col-span-1">
            <Icon icon="locate" />
          </div>
          <div>
            <p className="vt-highlight">
              {zoom >= 11
                ? address.village
                : zoom >= 6
                ? address.district
                : address.state}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TripsAggregateInfo
